import { getWrappingCellStyle } from "@platform/btx-grid-components";

import { financialsRowKinds } from "./types";

import type { FinancialsRowKind } from "./types";
import type { CellStyle } from "ag-grid-community";

const NOTES_ROW_KINDS: ReadonlySet<string> = new Set([
  financialsRowKinds.NOTES,
  financialsRowKinds.TOTAL_NOTES,
]);

/**
 * Resolves the cell style for a data column from its row kind. Notes rows get
 * word-level wrapping with horizontal scroll; every other kind uses the grid
 * default.
 */
export const getFinancialsNotesCellStyle = (
  kind?: FinancialsRowKind,
): CellStyle | undefined =>
  getWrappingCellStyle(!!kind && NOTES_ROW_KINDS.has(kind));
